import { Button, Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import React, { FC, useCallback, useState } from "react";

import useStyles from "./styles";
import DisplayFileComponent from "./subcomponents/DisplayFileComponent/DisplayFileComponent";
import UploadComponent from "./subcomponents/UploadComponent/UploadComponent";
import useBulkUploadMutation from "./useBulkUploadMutation";

interface TSetBulkUnlockCodesDialogProps {
  couponId: string;
  onClose: () => void;
}

const SetBulkUnlockCodesDialog: FC<TSetBulkUnlockCodesDialogProps> = ({
  couponId,
  onClose
}) => {
  const classes = useStyles({});
  const [selectedFile, setSelectedFile] = useState<File | undefined>(undefined);

  const {
    handleBulkUploadMutation,
    isBulkMutationLoading,
    errorMessage,
    handleClearErrorMessageFromApi,
    isRedirecting
  } = useBulkUploadMutation(couponId);

  const handleUpload = useCallback(() => {
    handleBulkUploadMutation(selectedFile);
  }, [handleBulkUploadMutation, selectedFile]);

  const handleSelectFile = useCallback((file: File) => {
    setSelectedFile(file);
  }, []);

  const handleUnselectFile = useCallback(() => {
    setSelectedFile(undefined);
    handleClearErrorMessageFromApi();
  }, []);

  const handleClose = useCallback(() => {
    if (!isBulkMutationLoading && !isRedirecting) {
      onClose();
    }
  }, [onClose, isBulkMutationLoading]);

  return (
    <Dialog
      onClose={handleClose}
      open
      maxWidth="sm"
      fullWidth
      onBackdropClick={handleClose}
    >
      <DialogTitle>
        <div className={classes.styledDialogTitle}>
          <div>Set Unlock Codes</div>
          {!isBulkMutationLoading && !isRedirecting ? (
            <Button onClick={handleClose} id="setBulkUnlockCodeDialogCloseBtn">
              <CloseIcon
                style={{
                  margin: "0"
                }}
              />
            </Button>
          ) : (
            <></>
          )}
        </div>
      </DialogTitle>
      <DialogContent>
        {selectedFile === undefined && (
          <UploadComponent onSelectFile={handleSelectFile} />
        )}
        {selectedFile !== undefined && (
          <DisplayFileComponent
            selectedFile={selectedFile}
            isLoading={isBulkMutationLoading}
            onUnselectFile={handleUnselectFile}
            onUpload={handleUpload}
            onClose={handleClose}
            errorMessageFromApi={errorMessage}
            isRedirecting={isRedirecting}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default SetBulkUnlockCodesDialog;
